import { render, staticRenderFns } from "./QuotesModalPhoto.vue?vue&type=template&id=335d34c3&scoped=true"
import script from "./QuotesModalPhoto.vue?vue&type=script&lang=js"
export * from "./QuotesModalPhoto.vue?vue&type=script&lang=js"
import style0 from "./QuotesModalPhoto.vue?vue&type=style&index=0&id=335d34c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d34c3",
  null
  
)

export default component.exports